// extracted by mini-css-extract-plugin
export default {"container":"Activities_container__jotgb","title":"Activities_title__J-dLl","detailBandera":"Activities_detailBandera__gJb9q"};